<div mat-dialog-title class="flex">
    <h2>Add Property File(s)</h2>
    <app-close-button (click)="close()"></app-close-button>
  </div>

  <mat-dialog-content>
    <app-file-uploader
      class="file-uploader"
      [adapter]="adapter"
      [class.busy]="uploading"
      (fileAdded)="onFileAdded($event)"
      (uploaded)="onUploaded($event)"
      (uploadFailed)="onUploadFailed($event)"
    ></app-file-uploader>

    <div class="mt-4 mb-2">
      <button class="mat-raised-button mat-primary" (click)="close()" *ngIf="filesAdded === 0">Close</button>
      <button class="mat-raised-button mat-primary" (click)="save()" *ngIf="filesAdded > 0" [disabled]="uploading" [class.mat-button-disabled]="uploading">Save</button>
      <span *ngIf="!error && uploading" class="ml-2">Uploading... Please wait</span>
      <span *ngIf="error" class="text-danger ml-2">Error: {{error}}</span>
    </div>
  </mat-dialog-content>
